import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryWeightPointFiltering, FactoryWeightPointAddEdit } from './Pages';

export const FactoryWeightPointRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={FactoryWeightPointFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={FactoryWeightPointAddEdit} />
    </Fragment>
)